import { useQuery } from "react-query";
import { getSecurityByOfficeId } from "../../../../actions/CarrierAgreementMgmt/Security";

export const useGetSecurityByOfficeId = (officeId) => {
  return useQuery(
    ["GetSecurityByOfficeId", officeId],
    () => getSecurityByOfficeId(officeId),
    { refetchOnWindowFocus: false }
  );
};
